{
  "Accessibility menu": "Toegankelijkheidsmenu",
  "Reset settings": "Instellingen resetten",
  "Close": "Sluiten",
  "Content adjustments": "Inhoudsaanpassingen",
  "Navigation adjustments": "Navigatieaanpassingen",
  "Align Left": "Links uitlijnen",
  "Adjust Font Size": "Lettergrootte aanpassen",
  "Highlight Title": "Titel markeren",
  "Highlight Links": "Links markeren",
  "Readable Font": "Leesbaar lettertype",
  "Colour adjustments": "Kleuraanpassingen",
  "Dark Contrast": "Donker contrast",
  "Light Contrast": "Licht contrast",
  "High Contrast": "Hoog contrast",
  "High Saturation": "Hoge verzadiging",
  "Low Saturation": "Lage verzadiging",
  "Monochrome": "Monochroom",
  "Tools": "Hulpmiddelen",
  "Reading Guide": "Leesgids",
  "Stop Animations": "Stop animaties",
  "Big Cursor": "Grote cursor",
  "Increase Font Size": "Lettergrootte vergroten",
  "Decrease Font Size": "Lettergrootte verkleinen",
  "Letter Spacing": "Letterafstand",
  "Line Height": "Regelhoogte",
  "Font Weight": "Lettergewicht",
  "Dyslexia Font": "Dyslexie lettertype",
  "Language": "Taal",
  "Accessibility widget": "Toegankelijkheidsmenu openen",
  "Accessibility Profiles": "Toegankelijkheidsprofielen",
  "Cognitive Disability": "Cognitieve beperking",
  "Seizure Safe": "Epilepsie veilig",
  "Accessibility statement": "Toegankelijkheidsverklaring"
}
